<div id="course-edit-overlay" [class]="visibility()">
  <div id="course-edit-container">
    <form id="course-edit-form">      
      <label for="course-name">Kursname</label>
      <input
        id="course-name"
        name="course-name"
        type="text"
        [(ngModel)]="model.name"
      />

      <label for="course-diffname">Alternativname</label>
      <input
        id="course-diffname"
        name="course-diffname"
        type="text"
        [(ngModel)]="model.diffname"
      />

      <label for="course-description">Beschreibung</label>
      <input
        id="course-description"
        name="course-description"
        type="text"
        [(ngModel)]="model.description"
      />

      <label for="course-level">Level</label>
      <input
        id="course-level"
        name="course-level"
        type="text"
        [(ngModel)]="model.level"
      />

      <label for="course-age_begin">Beginnalter</label>
      <input
        id="course-age_begin"
        name="course-age_begin"
        type="text"
        [(ngModel)]="model.age_begin"
      />   
      
      <label for="course-age_end">Maximalalter</label>
      <input
        id="course-age_end"
        name="course-age_end"
        type="text"
        [(ngModel)]="model.age_end"
      />       

      <label for="course-link">Link</label>
      <input
        id="course-link"
        name="course-link"
        type="text"
        [(ngModel)]="model.link"
      />      

      <label for="course-color">Farbe</label>
      <div
        class="color-picker-trigger"
        [style.background]="model.color"
        [colorPicker]="model.color"
        (colorPickerChange)="model.color = $event"
        [cpPosition]="'bottom'"
        [cpOutputFormat]="'hex'"
      >
      </div>
      <div class="color-value">{{ model.color }}</div>
    </form>

    <div style="text-align: center; margin-top: 1em;">
      <button class="button-save" (click)="save()">Save</button>
      <button class="button-close" (click)="close()">Close</button>
    </div>
  </div>
</div>
